import React, { useState } from 'react'

import { Box } from '@driftt/dds'

import FeedbackModal from 'components/FeedbackModal'
import SavedViewsSidebar from 'components/SavedViewsSidebar'
import SaveFilterModal from 'components/SaveFilterModal'
import Toast from 'components/Toast'
import useSavedFilterEditModal from 'hooks/useSavedFilterEditModal'
import useSavedFilters, { INACTIVE_FILTER } from 'hooks/useSavedFilters'

export interface SavedFiltersSidebarProps {
  accountsPage?: boolean
  toastText: string | undefined
  setToastText: (text: string | undefined) => void
}

const SavedFiltersSidebar = ({
  accountsPage = false,
  toastText,
  setToastText
}: SavedFiltersSidebarProps) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false)

  const {
    activeSavedFilter,
    defaultFilterId,
    savedFilters,
    updateActiveFilterId,
    updateDefaultFilterId,
    createNewSavedFilter,
    updateSavedFilter,
    removeSavedFilter
  } = useSavedFilters(setToastText, accountsPage)

  const {
    showSavedFilterModal,
    editableFilterGroups,
    editableSavedFilter,
    onOpenNewModal,
    onOpenEditModal,
    onCloseModal
  } = useSavedFilterEditModal()

  return (
    <Box css={{ padding: 0, background: '$white' }}>
      {showSavedFilterModal && (
        <SaveFilterModal
          editableGroups={editableFilterGroups}
          savedFilter={editableSavedFilter}
          defaultFilterId={defaultFilterId}
          onClose={onCloseModal}
          createSavedFilter={createNewSavedFilter}
          updateSavedFilter={updateSavedFilter}
          withDefaultFilter={accountsPage}
        />
      )}

      {showFeedbackModal && <FeedbackModal onClose={() => setShowFeedbackModal(false)} />}
      {toastText && <Toast text={toastText}></Toast>}
      <SavedViewsSidebar
        savedFilters={savedFilters}
        activeFilterId={activeSavedFilter?.id || INACTIVE_FILTER}
        defaultFilterId={defaultFilterId}
        setActiveFilterId={updateActiveFilterId}
        updateDefaultFilterId={updateDefaultFilterId}
        removeSavedFilter={removeSavedFilter}
        onOpenEditModal={onOpenEditModal}
        onCreateSavedFilter={onOpenNewModal}
        onShowFeedbackModal={() => setShowFeedbackModal(true)}
        isExternalPage={accountsPage}
      />
    </Box>
  )
}

export default SavedFiltersSidebar
